import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import {
  PaymentDerivedStatus,
  PaymentStatusNumerical,
  PayRunDerivedStatus,
} from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'payment-status',
  templateUrl: './payment-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class PaymentStatusComponent {
  private readonly cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;

  getPaymentStatus(value: any) {
    return PaymentStatusNumerical[value] || '-';
  }

  getPaymentDerivedStatus(value: any) {
    return PaymentDerivedStatus[value] || '-';
  }

  getPayRunDerivedStatus(value: any) {
    return PayRunDerivedStatus[value] || '-';
  }

  getStatusByType(value: any, statusType?: string) {
    if (!value && value !== 0) return '-';

    switch (statusType) {
      case 'payment_status':
        return this.getPaymentStatus(value);
      case 'payment_derived_status':
        return this.getPaymentDerivedStatus(value);
      case 'payrun_derived_status':
        return this.getPayRunDerivedStatus(value);
      default:
        // Default to payment derived status for backward compatibility
        return this.getPaymentDerivedStatus(value);
    }
  }
}
